import { render, staticRenderFns } from "./Film.vue?vue&type=template&id=acca0224&"
import script from "./Film.vue?vue&type=script&lang=js&"
export * from "./Film.vue?vue&type=script&lang=js&"
import style0 from "./Film.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports